/**
 * Mass DM via de worker (30-09-2026, Jordy).
 *
 * De FanCentro-verbindingen en de F2F-pagina zitten in de worker, niet in het
 * web. De server zet een preview of verzending daarom als opdracht klaar en
 * antwoordt meteen met `worker_job_id`; hier vragen we de stand op tot de
 * worker klaar is. Het resultaat is precies het antwoord dat de route vroeger
 * direct gaf, dus de rest van het venster verandert niet.
 *
 * Een FanCentro-preview bladert door alle contacten en kan even duren; daarom
 * geen lange HTTP-aanvraag maar opvragen per seconde.
 */
import { api, ApiError } from './api'

const OPVRAAG_MS = 1000
const MAX_MS = 5 * 60_000

interface Stand {
  status: string
  result?: unknown
  http_status?: number | null
  detail?: string | null
}

export async function viaWorker<T>(pad: string, body: unknown): Promise<T> {
  // 01-10-2026: een Mass DM met media gaat als formulier naar /mass-media.
  const eerste = body instanceof FormData
    ? await api.postForm<Record<string, unknown>>(pad, body)
    : await api.post<Record<string, unknown>>(pad, body)
  if (!eerste || typeof eerste !== 'object' || !('worker_job_id' in eerste)) {
    return eerste as T // een server zonder worker-wachtrij antwoordt meteen
  }
  const id = eerste.worker_job_id
  const tot = Date.now() + MAX_MS
  while (Date.now() < tot) {
    await new Promise((r) => window.setTimeout(r, OPVRAAG_MS))
    const st = await api.get<Stand>(`/api/admin/conversations/mass-message/worker-job/${id}`)
    if (st.status === 'done') return st.result as T
    if (st.status !== 'queued' && st.status !== 'running') {
      throw new ApiError(st.http_status ?? 500, st.detail || 'Mass DM failed.')
    }
  }
  throw new ApiError(504,
    'The Mass DM service is still busy. Check Mass messages before trying again.')
}
